import {
  AlertTriangle,
  CheckCircle2,
  Clock,
  Loader2,
  XCircle,
  type LucideIcon,
} from 'lucide-react';
import type { PaymentReceiptTone } from '../utils/payment-receipt-view.util';

const TONE_STYLES: Record<
  PaymentReceiptTone,
  { icon: LucideIcon; circle: string }
> = {
  success: {
    icon: CheckCircle2,
    circle: 'bg-alba-success-green-500/10 text-alba-success-green-600',
  },
  processing: { icon: Clock, circle: 'bg-alba-blue-500/10 text-alba-blue-600' },
  warning: {
    icon: AlertTriangle,
    circle: 'bg-alba-warning-orange-400/10 text-alba-warning-orange-500',
  },
  error: {
    icon: XCircle,
    circle: 'bg-alba-error-red-500/10 text-alba-error-red-600',
  },
};

type PaymentReceiptStatusProps = {
  tone: PaymentReceiptTone;
  title: string;
  message: string;
  /** A página está relendo o comprovante: o relógio vira um indicador girando. */
  refreshing?: boolean;
};

export function PaymentReceiptStatus({
  tone,
  title,
  message,
  refreshing = false,
}: PaymentReceiptStatusProps) {
  const { icon, circle } = TONE_STYLES[tone];
  const Icon = refreshing ? Loader2 : icon;

  return (
    <header
      role='status'
      aria-live='polite'
      className='flex flex-col items-center gap-3 text-center'
    >
      <span
        className={`flex h-16 w-16 items-center justify-center rounded-full ${circle}`}
      >
        <Icon
          aria-hidden='true'
          className={`h-9 w-9 ${refreshing ? 'animate-spin' : ''}`}
          strokeWidth={1.8}
        />
      </span>
      <h1 className='text-xl font-bold text-alba-black-500 sm:text-2xl'>
        {title}
      </h1>
      <p className='text-sm leading-relaxed text-alba-gray-600 sm:text-base'>
        {message}
      </p>
    </header>
  );
}
